export default __webpack_public_path__ + "7bb6a035a8f122e90130cad84a564188.svg";